define('plugin/gallery/collection/GalleryCollection',['require','lib/collection/BaseCollection','plugin/gallery/model/GalleryModel'],function (require) {

    var BaseCollection = require('lib/collection/BaseCollection');
    var GalleryModel = require('plugin/gallery/model/GalleryModel');

    /**
     * Gallery collection
     *
     * @class GalleryCollection
     */
    return BaseCollection.extend({
        url: '/ext/gallery/',
        model: GalleryModel,

        comparator: function (model) {
            return parseInt( model.get('order') );
        }

    });

});
